import "@/App.css";
import { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import { ReactLenis } from "lenis/react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Preloader from "@/components/landing/Preloader";
import CursorGlow from "@/components/landing/CursorGlow";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import EditorialMarquee from "@/components/landing/EditorialMarquee";
import WhyUs from "@/components/landing/WhyUs";
import Worldwide from "@/components/landing/Worldwide";
import Plans from "@/components/landing/Plans";
import Process from "@/components/landing/Process";
import About from "@/components/landing/About";
import Testimonials from "@/components/landing/Testimonials";
import Faq from "@/components/landing/Faq";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import FloatingActions from "@/components/landing/FloatingActions";
import LaunchOffer from "@/components/landing/LaunchOffer";
import LegalPage from "@/components/landing/LegalPage";
import Admin from "@/components/Admin";
import { LanguageProvider } from "@/i18n";
import { track } from "@/track";

function Landing() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 1900);
    return () => clearTimeout(t);
  }, []);

  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="min-h-screen bg-navy-900 text-cream overflow-x-clip">
        <AnimatePresence>{loading && <Preloader />}</AnimatePresence>
        <CursorGlow />
        <div className="noise-overlay" aria-hidden="true" />
        <Navbar />
        <main>
          <Hero />
          <EditorialMarquee />
          <WhyUs />
          <Worldwide />
          <Plans />
          <Process />
          <About />
          <Testimonials />
          <Faq />
          <Contact />
        </main>
        <Footer />
        <FloatingActions />
        <LaunchOffer />
        <Toaster theme="dark" position="bottom-left" />
      </div>
    </ReactLenis>
  );
}

function PageTracker() {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return;
    const key = `ea_pv_${location.pathname}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");
    track("page_view", location.pathname);
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <PageTracker />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/privacy" element={<LegalPage doc="privacy" />} />
          <Route path="/terms" element={<LegalPage doc="terms" />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
